package org.example.project.screens_cus

import androidx.compose.runtime.Composable
import org.example.project.dashboard.CusBereichWrapper

@Composable
fun CusHofDashboard() {
    CusBereichWrapper(
        screenKey = "HofDashboard",
        buttonLabels = mapOf(
            "WarenausgangVorbereitungScreen" to "WA-Vorbereitung",
            "AuftraegeDashboardScreen" to "Aufträge"
        )
    )
}
